<template>
  <div>
    <ConfiguracoesCatalogo
      :dialog="dialog"
      @dialogClose="dialogClose"
      :id="id"
    />
    <v-data-table
      :headers="headers"
      :items="catalogos"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.identificadorCatalogo`]="{ item }">
        <a :href="link(item)" target="_blank">{{
          item.identificadorCatalogo
        }}</a>
      </template>
      <template v-slot:[`item.dt_expiracao`]="{ item }"
        ><p>{{ formataData(item.dt_expiracao) }}</p>
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        <p>
          {{ formataData(item.updatedAt) + " " + formataHora(item.updatedAt) }}
        </p>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <p>
          {{ formataData(item.createdAt) + " " + formataHora(item.createdAt) }}
        </p>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-icon :title="titulo(item)" :color="cor(item)">{{
          icone(item)
        }}</v-icon>
      </template>
      <template v-slot:[`item.pagamentos`]="{ item }">
        <v-icon @click="configurarCatalogo(item.id)">mdi-cash-multiple</v-icon>
      </template>
      <template v-if="userMaster" v-slot:[`item.excluir`]="{ item }">
        <v-icon @click="excluirCatalogo(item.id)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfiguracoesCatalogo from "./pagamentos/PagamentosCatalogo.vue";

export default {
  components: { ConfiguracoesCatalogo },
  props: ["catalogos"],
  data: function () {
    return {
      id: "",
      dialog: false,
      headers: [
        { text: "ID", value: "id", shortable: false },
        { text: "Nome", value: "nome", shortable: false },
        {
          text: "Identificador",
          value: "identificadorCatalogo",
          shortable: false,
        },
        {
          text: "Dt.Criação",
          value: "createdAt",
          shortable: false,
          align: "center",
        },
        // {
        //   text: "Hr.Criação",
        //   value: "createdAtHora",
        //   shortable: false,
        //   align: "center",
        // },
        {
          text: "Dt.Alt",
          value: "updatedAt",
          shortable: false,
          align: "center",
        },
        // {
        //   text: "Hr.Alt",
        //   value: "updatedAtHora",
        //   shortable: false,
        //   align: "center",
        // },
        {
          text: "Expiração",
          value: "dt_expiracao",
          shortable: false,
          align: "center",
        },
        { text: "Status", value: "status", shortable: false, align: "center" },
        {
          text: "Pagamentos",
          value: "pagamentos",
          shortable: false,
          align: "center",
        },
        { text: "", value: "excluir", shortable: false, align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters(["userAdmin", "userMaster"]),
  },
  methods: {
    link(item) {
      return `https://sicecommerce.com.br/${item.identificadorCatalogo}`;
    },
    formataData(item) {
      var date = new Date(item);
      return date.toLocaleDateString("pt-BR");
    },
    formataHora(item) {
      var date = new Date(item);
      return date.toLocaleTimeString("pt-BR");
    },
    titulo(item) {
      var currentDate = new Date();
      var catalogoDate = new Date(item.dt_expiracao);
      return catalogoDate.getTime() <= currentDate.getTime()
        ? "Expirado"
        : "Ativo";
    },
    icone(item) {
      var currentDate = new Date();
      var catalogoDate = new Date(item.dt_expiracao);
      return catalogoDate.getTime() <= currentDate.getTime()
        ? "mdi-calendar-remove"
        : "mdi-calendar-check";
    },
    cor(item) {
      var currentDate = new Date();
      var catalogoDate = new Date(item.dt_expiracao);
      return catalogoDate.getTime() <= currentDate.getTime() ? "red" : "green";
    },
    configurarCatalogo(id) {
      this.id = id;
      this.dialog = true;
    },
    dialogClose() {
      this.dialog = false;
    },
    async excluirCatalogo(id) {
      try {
        this.loading = true;
        await this.axios.delete(`/catalogos/${id}/`);
        this.$store.dispatch("showSuccess", "Catálogo excluído com sucesso!");
        this.$emit("loadCatalogos");
        //this.dialogClose();
      } catch (error) {
        this.$store.dispatch("showError", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>